import { ref, watch } from 'vue'
import { useRoute } from 'vue-router/composables'
import { asyncTrack } from '@/track'
import { useHistoryStore } from '@/stores'

export function convertPath(input: string) {
  const trimmed = input.replace(/^\/+|\/+$/g, '')
  return trimmed.replace(/\//g, ':')
}

export function setPageViewParams(title: string, path: string) {
  const dynamicArrs = ['book', 'chapter', 'chapter-scroll', 'collection', 'ranking']
  if (dynamicArrs.includes(title)) {
    // chapter-scroll 路由路径为 /content/:contentId/scroll/:chapterId，比 chapter 路由多一段字面量 scroll，
    // 转换前去掉这一段，使 title 与 chapter 路由保持一致的 content:contentId:chapterId 三段格式
    const normalizedPath = title === 'chapter-scroll' ? path.replace('/scroll/', '/') : path
    title = convertPath(normalizedPath)
  }

  if (title === 'home')
    title = 'index'

  return title
}

export function pageViewTrack(key: string) {
  const historyStore = useHistoryStore()
  const prevPage: any = historyStore.$state.prevPage

  // login 页面在单独域名, 单独上报
  if (key === 'login')
    return

  asyncTrack('biz_pageview', {
    host: window.location.host,
    url: window.location.href,
    tab: document.title,

    title: key,
    route_title: prevPage?.route_title,
  })
}

export function directPageViewTrack(key: string, routeTitle: string) {
  asyncTrack('biz_pageview', {
    host: window.location.host,
    url: window.location.href,
    tab: document.title,

    title: key,
    route_title: routeTitle,
  })
}

// 弹窗使用
export function directPageTimeReport(key: string, duration = 0, lastPage: string) {
  asyncTrack('biz_pagetime', {
    title: key,
    duration: Math.floor(duration / 1000) || 0,
    route_title: lastPage,
  })
}

export function usePageTime() {
  const route = useRoute()
  const enterTime = ref(Date.now())

  const pageTimeReport = function (duration: number, oldVal: string, newVal: string) {
    if (duration === undefined || duration < 50)
      return

    if (!oldVal)
      return

    if (newVal === '/')
      newVal = 'index'

    if (oldVal === '/')
      oldVal = 'index'

    asyncTrack('biz_pagetime', {
      duration: Math.floor(duration / 1000) || 0,
      route_title: convertPath(oldVal),
      title: convertPath(newVal),
    })
  }

  watch(
    () => route.path,
    (newVal, oldVal) => {
      const leaveTime = Date.now()
      const duration = leaveTime - enterTime.value
      pageTimeReport(duration, oldVal, newVal)

      // 数据更新
      enterTime.value = Date.now()
    },
  )
}
